<template>
	<transition name="slide-upp">
		<div v-if="flash" class="flash" :class="state" v-html="flash"></div>
	</transition>
</template>

<script>
export default {
	props: {
		flash: {
			type: String,
			default: null
		},
		state: {
			type: String,
			default: 'error'
		}
	}
}
</script>

<style scoped>
.flash.error {
	color: tomato;
}

.flash.success {
	color: var(--quomi-primary);
}

.flash {
	max-height: 100px;
}

.slide-upp-enter,
.slide-upp-leave-to {
	max-height: 0px;
}

.slide-upp-leave-active,
.slide-upp-enter-active {
	overflow: hidden;
	transition: all 0.6s ease;
}
</style>
